import posthog from 'posthog-js'

posthog.init(process.env.REACT_APP_VITE_PUBLIC_POSTHOG_KEY || '', {
  api_host: process.env.REACT_APP_VITE_PUBLIC_POSTHOG_HOST || '',
  autocapture: true,
  loaded: (ph) => {
    window.PH = ph
  },
})

export default posthog
